import { Injectable } from '@angular/core';
import Intercom from '@intercom/messenger-js-sdk';
import { FeatureFlagService } from './feature-flag.service';
import { EnvService } from './env.service';
declare global {
  interface Window {

  }
}
export interface IntercomUserData {
  email?: string;
  user_id?: string;
  name?: string;
  created_at?: number;
  [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class IntercomService {
  private enableChatbot: boolean;

  constructor(private featureFlagService: FeatureFlagService, private envService: EnvService) {

  }

  boot(userData: IntercomUserData) {

      this.enableChatbot = this.featureFlagService.isFeatureEnabled('help-chatbot-enabled');

      if (this.enableChatbot) {
        const intercomInitData = { app_id: this.envService.intercomAppId, ...userData };
        Intercom(intercomInitData);
      }

  }

  update(userData: Partial<IntercomUserData>) {
    if (window && window.Intercom) {
      window.Intercom('update', userData);
    }
  }

  shutdown() {
    if (window && window.Intercom) {
      window.Intercom('shutdown');
    }
  }
}
